import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import AccountForm from "../../components/AccountForm";
import { paperStyles } from "./ProfilePage.styles";
import PaymentMethods from "../../components/PaymentOptions/PaymentOptions.view";
import { useInfoBar } from "../../hooks/useInfoBar";
import { getColors } from "../../utils";
export const ProfilePage = () => {
  const infoBar = useInfoBar();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 5 }}>
      <Typography variant="h4" sx = {{ color: getColors().text }}>Mon compte</Typography>

      <Paper sx={paperStyles}>
        <AccountForm isMobile={infoBar?.isMobile} />
      </Paper>
      <Paper sx={paperStyles}>
        <PaymentMethods isMobile={infoBar?.isMobile} />
      </Paper>
    </Box>
  );
};
